import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { getAuthHeaders } from '../../auth';

const API_DEPARTMENTS = '/api/admin/departments/';
const API_USERS = '/api/admin/users/';
const API_SEND = '/api/admin/notifications/send-fund-request-release/';

const FundRequestReleaseModal = ({ row, onClose, onSent }) => {
  const [departments, setDepartments] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedDepts, setSelectedDepts] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [sending, setSending] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [deptRes, userRes] = await Promise.all([
          fetch(API_DEPARTMENTS, { headers: getAuthHeaders(false) }),
          fetch(API_USERS, { headers: getAuthHeaders(false) })
        ]);
        if (!deptRes.ok || !userRes.ok) throw new Error('Failed to load recipients');
        const deptData = await deptRes.json();
        const userData = await userRes.json();
        setDepartments(Array.isArray(deptData) ? deptData : deptData.results || []);
        const userList = Array.isArray(userData) ? userData : userData.results || [];
        setUsers(userList.map(u => ({ id: u.id, text: `${u.first_name || ''} ${u.last_name || ''}`.trim() || u.username })));
      } catch (e) {
        toast.error(e.message || 'Failed to load recipients');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleDeptChange = (e) => {
    const opts = Array.from(e.target.selectedOptions).map(o => o.value);
    setSelectedDepts(opts);
  };

  const handleUserChange = (e) => {
    const opts = Array.from(e.target.selectedOptions).map(o => Number(o.value));
    setSelectedUsers(opts);
  };

  const handleSend = async () => {
    if (!selectedDepts.length && !selectedUsers.length) {
      toast.error('Select at least one department or user.');
      return;
    }
    setSending(true);
    try {
      const res = await fetch(API_SEND, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({
          idf_no: row.idf_no || '',
          customer_name: row.customer_name || '',
          shipment_type: row.shipment_type || '',
          department_ids: selectedDepts.map(Number),
          user_ids: selectedUsers,
          link: '/dashboard/FundRequest'
        })
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || 'Failed to send notifications');
      toast.success(`Notifications sent to ${data.created_count} user(s)`);
      window.dispatchEvent(new CustomEvent('fund-request-notification-sent'));
      onSent();
      onClose();
    } catch (e) {
      toast.error(e.message || 'Failed to send notifications');
    } finally {
      setSending(false);
    }
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      backgroundColor: 'rgba(0,0,0,0.55)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 20
    }}>
      <div style={{
        backgroundColor: '#fff', borderRadius: 8, width: '100%', maxWidth: 520,
        boxShadow: '0 10px 40px rgba(0,0,0,0.25)', overflow: 'hidden'
      }}>
        <div style={{
          backgroundColor: '#3f6b32', color: '#fff', padding: '14px 18px',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center'
        }}>
          <h3 style={{ margin: 0, fontSize: 16 }}>Fund Request Release</h3>
          <button onClick={onClose} disabled={sending} style={{ background: 'none', border: 'none', color: '#fff', fontSize: 20, cursor: 'pointer' }}>×</button>
        </div>

        <div style={{ padding: 20 }}>
          <p style={{ margin: '0 0 14px 0', fontWeight: 'bold', color: '#333' }}>
            Fund Request released for:
          </p>
          <div style={{ background: '#f8f9fa', padding: 12, borderRadius: 6, marginBottom: 16, fontSize: 13, lineHeight: 1.5 }}>
            <div><strong>IDF:</strong> {row.idf_no || '-'}</div>
            <div><strong>Client:</strong> {row.customer_name || '-'}</div>
            <div><strong>Shipment Type:</strong> {row.shipment_type || '-'}</div>
          </div>

          {loading ? (
            <div>Loading recipients...</div>
          ) : (
            <>
              <div style={{ marginBottom: 14 }}>
                <label style={{ display: 'block', fontWeight: 'bold', marginBottom: 6, fontSize: 13 }}>Departments (multi-select)</label>
                <select multiple size={5} onChange={handleDeptChange} style={{ width: '100%', padding: 6 }}>
                  {departments.map(d => (
                    <option key={d.id} value={d.id}>{d.name}</option>
                  ))}
                </select>
              </div>

              <div style={{ marginBottom: 20 }}>
                <label style={{ display: 'block', fontWeight: 'bold', marginBottom: 6, fontSize: 13 }}>Individual Users (multi-select)</label>
                <select multiple size={5} onChange={handleUserChange} style={{ width: '100%', padding: 6 }}>
                  {users.map(u => (
                    <option key={u.id} value={u.id}>{u.text}</option>
                  ))}
                </select>
              </div>

              <div style={{ textAlign: 'right' }}>
                <button className="btn btn-secondary" onClick={onClose} disabled={sending} style={{ marginRight: 10 }}>Cancel</button>
                <button className="btn btn-success" onClick={handleSend} disabled={sending || (!selectedDepts.length && !selectedUsers.length)}>
                  {sending ? 'Sending...' : 'Send'}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default FundRequestReleaseModal;
